module.exports = __webpack_public_path__ + "d1efcd4d126837fe0dcf9b6cf3a00d64.ttf";